module.exports = __webpack_public_path__ + "ae8d6394a3263a6f3465138a2c73c692.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/train/view/home/images/page.png
// module id = 184
// module chunks = 1